import axios from 'axios';
import router from '@/router'

let baseUrl = "http://lcsjfx.com/";



// 带token请求
const httpRequest = (opts, data) => {

	
	let username = localStorage.getItem('footy_username');
	let token = localStorage.getItem('footy_token');

	let postUrl =  opts.url;
	if(postUrl.includes("\?")){
		postUrl = baseUrl + opts.url + "&ptlx=FootyForecast&qdly=web&account="+username+"&token="+token;
	}else{
		postUrl =  baseUrl + opts.url + "?ptlx=FootyForecast&qdly=web&account="+username+"&token="+token;
	}
	
	let httpDefaultOpts = {
		
		url:postUrl,
		
		data: data,
		method: opts.method,
		header: opts.method == 'get' ? {
			'X-Requested-With': 'XMLHttpRequest',
			"Accept": "application/json",
			"Content-Type": "application/json; charset=UTF-8"
		} : {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json; charset=UTF-8'
		},
		dataType: 'json',
	}
	let promise = new Promise(function(resolve, reject) {
		axios.request(httpDefaultOpts).then(
			(res) => {
				if (res.data.status == 0) {
					// ElMessage({
					// 	message:  res.data.message,
					// 	type: 'warning',
					//   })
					router.push('/login');
					return;
				}
				if (res.data.status == 4 || res.data.status == 5) {
					// ElMessage({
					// 	message:  res.data.message,
					// 	type: 'warning',
					//   })
					router.push('/login');
					return;
				}
				
				resolve(res)
			}
		).catch(
			(response) => {
				reject(response)
			}
		)
	})
	return promise
};

//带Token请求
const openHttpRequest = (opts, data) => {
	
	let postUrl =  opts.url;
	if(postUrl.includes('\?')){
		postUrl = baseUrl + opts.url + "&ptlx=FootyForecast&qdly=web";
	}else{
		postUrl =  baseUrl + opts.url + "?ptlx=FootyForecast&qdly=web";
	}
	
	let httpDefaultOpts = {
		
		url:postUrl,
		
		data: data,
		method: opts.method,
		header: opts.method == 'get' ? {
			'X-Requested-With': 'XMLHttpRequest',
			"Accept": "application/json",
			"Content-Type": "application/json; charset=UTF-8"
		} : {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json; charset=UTF-8'
		},
		dataType: 'json',
	}
	let promise = new Promise(function(resolve, reject) {
		axios.request(httpDefaultOpts).then(
			(res) => {
				resolve(res)
			}
		).catch(
			(response) => {
				reject(response)
			}
		)
	})
	return promise

};

// 拦截器
const hadToken = () => {
	let username = localStorage.getItem('footy_username');
	let token = localStorage.getItem('footy_token');

	if (!username) {
		// ElMessage({
		//   message: '请先登录',
		//   type: 'warning',
		// })
		router.push('/login');
		return false;
	}
	if (!token) {
		// ElMessage({
		// //   message: '会话已过期，请重新登录',
		//   type: 'warning',
		// })
		router.push('/login');
		return false;
	}
	return true;
}
export default {
	baseUrl,
	httpRequest,
	openHttpRequest,
	hadToken
}
